// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3arSG","colBig":"styles_colBig__3XzWe","colSmall":"styles_colSmall__3Bspz"};